import React from 'react';
export const AlertMessage = ({txt, handleCloseAlert}) => {
    let flagNotShowAlert = localStorage.getItem('flagNotShowAlert');
    function eventClosePopup(){
        localStorage.setItem('flagCloseAlert', '1');
        handleCloseAlert();
    }
    if((flagNotShowAlert && flagNotShowAlert === '1')){
        localStorage.removeItem('flagNotShowAlert');
        //localStorage.removeItem('flagCloseAlert');
        handleCloseAlert();        
        return '';
    }
    return (
        <section className="popup__overlay">
            <article className="popup popup-alert-mess">
                <section className='popup__header'>
                    <div className="popup__icon"></div>
                    <div className='popup__title'>お知らせ</div>
                </section>
                <section className='popup__content'>
                <div className="content" dangerouslySetInnerHTML={{__html: txt}}></div>		
                    <div className="popup__button"><button onClick={e => eventClosePopup()}>閉じる</button></div>		
                </section>
            </article>
        </section>
    )
}